<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">诊断试剂开发平台</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:65%; height:100%;">'
      + '<p style="margin-right : 20px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">诊断试剂开发平台涵盖成像测试能力、基因蛋白分析和试剂开发\n' +
      '三个流程模块。该平台以解决临床问题为导向，聚焦诊断试剂开发中\n' +
      '涉及的各环节，提供对应的技术支撑、咨询、注册报批、专利申报等\n' +
      '全流程服务。</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:35%; height:100%;">'
      + '<p style="margin-left : 120px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/linhe.jpg" style="float: left; width: 180px; margin-right: 170px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left: 130px;text-align: justify"><span style="font-size: 16px;"><b>负责人：何琳</b></span></p>'
      + '</div>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;成像测试能力&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：300kV冷冻透射电子显微镜、活细胞超高分辨率多光子激光共聚焦显微镜、 X射线\n' +
      '显微镜、多模式小动物超声/光声成像系统。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：跨尺度多维度多模态的超微结构解析、生物大分子三维结构解析、 亚细胞结构和动\n' +
      '力学、微区元素分析及全套样品制备。</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;基因蛋白分析 &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备： 高通量基因分析系统、数字PCR仪、纳升液相色谱-四极杆飞行时间串联质谱联用\n' +
      '仪、分子相互作用仪 。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：高通量基因组检测、DNA绝对定量、工作站批量建库、蛋白定性定量与相互作用\n' +
      '分析。</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;试剂开发 &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：配套研发实验室。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：诊断试剂开发、评估、注册报批、专利申报等一站式全流程咨询 服务。</span></p>'


      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biomedical_imaging_en_2.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">联系人</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">何琳</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: lhe@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Phone: +86-021 - 34208498 - 6208</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service15/index.vue